import React from 'react';

const Navigation = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="content-bottom-navbar">
      <div className="main-content-nav">
        <div className="portfolio-w-full">
          <ul className="content__list">
            <li className="content__item">
              <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }} className="link link--helike">
                <span>
                  <i className="ph ph-house-simple"></i>
                  <span className="d-sm-none">Home</span>
                </span>
              </a>
            </li>
            <li className="content__item">
              <a href="#projects" onClick={(e) => { e.preventDefault(); scrollToSection('projects'); }} className="link link--helike">
                <span>
                  <i className="ph ph-grid-four"></i>
                  <span className="d-sm-none">Projects</span>
                </span>
              </a>
            </li>
            <li className="content__item">
              <a href="#skills" onClick={(e) => { e.preventDefault(); scrollToSection('skills'); }} className="link link--helike">
                <span>
                  <i className="ph ph-file-text"></i>
                  <span className="d-sm-none">Skills</span>
                </span>
              </a>
            </li>
            <li className="content__item">
              <a href="#experience" onClick={(e) => { e.preventDefault(); scrollToSection('experience'); }} className="link link--helike">
                <span>
                  <i className="ph ph-briefcase"></i>
                  <span className="d-sm-none">Experience</span>
                </span>
              </a>
            </li>
            <li className="content__item">
              <a href="#education" onClick={(e) => { e.preventDefault(); scrollToSection('education'); }} className="link link--helike">
                <span>
                  <i className="ph ph-graduation-cap"></i>
                  <span className="d-sm-none">Education</span>
                </span>
              </a>
            </li>
            <li className="content__item">
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }} className="link link--helike">
                <span>
                  <i className="ph ph-envelope"></i>
                  <span className="d-sm-none">Contact</span>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
